// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".small-font[data-v-04be1244] {\n  font-size: 10px;\n}\n.cell > article.box[data-v-04be1244] {\n  min-height: 300px;\n}", ""]);
// Exports
module.exports = exports;
